import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"


import { computed, reactive, onMounted } from 'vue'
import DetailCard from '@/components/DetailCard'
import { customerCodeDetail } from '@/api/overseasSales/customerCenter'
import { customerPhaseEnum, arkCodeStatusEnum } from '@/views/overseasSales/commonEnum/dataConfig'
import { useI18n } from 'vue-i18n'
const __default__ = { name: 'BaseMessage' }

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  id: {
    type: String
  }
},
  setup(__props) {

const { t } = useI18n()
const props = __props
const columns = computed(() => [
  { title: t('arkCode.arkCode'), dataIndex: 'arkCode' },
  {
    title: t('arkCode.stage'),
    dataIndex: 'stage',
    node: 'cos-select',
    attrs: {
      options: customerPhaseEnum
    }
  },
  { title: t('arkCode.arkAccount'), dataIndex: 'arkAccount' },
  { title: t('arkCode.level'), dataIndex: 'level' },
  { title: t('arkCode.arkContact'), dataIndex: 'arkContactName' },
  { title: t('arkCode.amount'), dataIndex: 'amount' },
  { title: t('arkCode.arkContactMobile'), dataIndex: 'arkContactMobile' },
  { title: t('common.updateTime'), dataIndex: 'updateTime' },
  { title: t('arkCode.sellerName'), dataIndex: 'sellerName' },
  { title: t('common.createTime'), dataIndex: 'createTime' },
  {
    title: t('custom.arkStatus'),
    dataIndex: 'status',
    node: 'cos-select',
    attrs: {
      options: arkCodeStatusEnum
    }
  }
])
const data = reactive({})
const fetch = () => {
  if (props.id) {
    customerCodeDetail(props.id).then((res) => {
      Object.assign(data, res.data)
    })
  }
}
onMounted(() => {
  fetch()
})

return (_ctx: any,_cache: any) => {
  const _component_a_form = _resolveComponent("a-form")!

  return (_openBlock(), _createBlock(_component_a_form, {
    ref: "formRef",
    name: "advanced_search"
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(DetailCard), {
        columns: columns.value,
        title: _unref(t)('common.baseTabs'),
        data: data
      }, null, 8, ["columns", "title", "data"])
    ]),
    _: 1
  }, 512))
}
}

})